<script setup lang="ts">
import { Ticker } from 'motion-plus-vue'

const items = [
  {
    image: `${S3_ASSETS_URL}/home/brands/dos-bocas.png`,
    link: 'https://dosbocasatl.com/',
    alt: 'Dos Bocas',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/kali.png`,
    link: 'https://kalirestaurant.com/',
    alt: 'Kali Restaurant',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/gunshow.png`,
    link: 'https://gunshowatl.com/',
    alt: 'Gunshow',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/belching-beaver.png`,
    link: 'https://belchingbeaver.com/',
    alt: 'Belching Beaver Brewery',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/southpark-seafood.png`,
    link: 'https://southparkseafood.com/',
    alt: 'Sustainable Seafood Restaurant + Oyster Bar.',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/phils-bbq.png`,
    link: 'https://philsbbq.com/',
    alt: 'Phil\'s BBQ',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/second-nature.png`,
    link: 'https://secondnaturepb.com/',
    alt: 'Second Nature',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/bar-bacoa.png`,
    link: 'https://barbacoaatl.com/',
    alt: 'Bar.bacoa',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/eight-sushi.png`,
    link: 'https://eightsushiatl.com/',
    alt: 'Eight Sushi Lounge',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/working-class.png`,
    link: 'https://workingclasssd.com/',
    alt: 'Working Class',
  },
  {
    image: `${S3_ASSETS_URL}/home/brands/mr-brews.png`,
    link: 'https://mrbrewstaphouse.com/',
    alt: 'Mr Brews Taphouse',
  },
]
</script>

<template>
  <Ticker
    :hover-factor="0"
    :gap="0"
    class="max-w-full"
    :style="{
      maskImage: 'linear-gradient(90deg, transparent, black 15%, black 85%, transparent)',
    }"
  >
    <a
      v-for="(item, index) in items"
      :key="index"
      :href="item.link"
      target="_blank"
      rel="noopener nofollow"
      class="mr-20 inline-flex items-center justify-center"
    >
      <img
        :src="item.image"
        :alt="`${item.alt} logo`"
        class="h-20"
      >
    </a>
  </Ticker>
</template>
